export default class Popup {
	constructor () {
		this.popup = document.querySelector('.covid19-popup');

		if (this.popup) {
			this.openPopup();
			this.popup.querySelector('.covid19-close').addEventListener('click', this.closePopup.bind(this));
		}
	}

	openPopup () {
		this.popup.classList.add('is-open');
		document.body.classList.add('has-popup');
	}

	closePopup () {
		this.popup.classList.remove('is-open');
		document.body.classList.remove('has-popup');
	}
}
